import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';
import cPdtDtl from './cPdtDtl';

class iPdtDtl extends cPdtDtl {
    
  $id_stgs = {
    b_useCm60: false,
  };

  constructor(props) {
    super(props);
    this.state = cf.myRN_crt_stss(
        this.$cd_stss,
        this.$id_stss
    );
  }

  $id_stss = {
    s_cm5ii110: '0', // 時間数
    s_cm5ii210: '0', // 30分延長料金
    s_cm5ii220: '0', // 60分延長料金
    s_cm5ii310: '0', // 最大数量
  };

  $ilp_loads = () => [
    cp.$cp_hlr_cm5t({
      mode: 'items',
      state: 'sld_cm5tss',
      cnd: bf.q('[cm5tb11k]="{}" AND IFNULL([cm5tcz10],"10")<>"0"'.f(
        global.c?.state.sgcd_pageCmns?.cm20_key
      )),
    }),
    ip.$ip_load_cm5i({
      mode: 'set',
      b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
      cm50_key: global.c?.state.sgcd_pageCmns?.cm50_key,
    }),
  ];

  $ilp_upds = () => [
    ip.$ip_ups_cm5i(),
  ];

//        b_rhtVsb={true}
  render(){
//        b_rhtVsb={bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80']) ? true : false}
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80']) ? true : false}
        rhtPfx={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        n_bdyW={ic.gn_maxBdyW}
        d_hdrs={{
          pfx: iv._get_hdrPfx('商品情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Pck',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm50t110',
              pfx:'商品種別',
              ld_itemss: [
                {key:'0', pfx: '未選択'},
                {key:'110', pfx: 'コース（時間指定）'},
                {key:'120', pfx: 'コース（時刻指定）'},
                {key:'220', pfx: 'コース延長'},
                {key:'210', pfx: 'ポイント付ドリンク'},
                {key:'230', pfx: 'シャンパンドリンク'},
                {key:'290', pfx: 'その他'},
              ],
            },
            {
              type:'Pck',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm50t120',
              pfx:'商品分類',
              ld_itemss: global.c?.state.sld_cm5tss,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm50c310',
              pfx:'商品名',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:(bf.i(global.c?.state.s_cm50t110, ['110'])) ? true : false, // コースの場合
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5ii110',
              pfx:'コース時間（分）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:(bf.i(global.c?.state.s_cm50t110, ['120'])) ? true : false, // コースの場合
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5ii110',
              pfx:'コース終了時刻（hhmm）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:(bf.i(global.c?.state.s_cm50t110, ['220'])) ? true : false, // コースの場合
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5ii110',
              pfx:'延長時間（分）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:(bf.i(global.c?.state.s_cm50t110, ['220'])) ? false : true, // コースの場合
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm50i110',
              pfx:'基本料金（税抜）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:(bf.i(global.c?.state.s_cm50t110, ['110', '120'])) ? true : false, // コースの場合
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5ii210',
              pfx:'３０分延長料金（税抜）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:(bf.i(global.c?.state.s_cm50t110, ['110', '120'])) ? true : false, // コースの場合
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5ii220',
              pfx:'６０分延長料金（税抜）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:(bf.i(global.c?.state.s_cm50t110, ['110', '120'])) ? false : true, // コース以外の場合
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5ii310',
              pfx:'最大数量（0：無制限）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm50cx10',
              pfx:'表示順',
              b_mln:false,
            },
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm50cz10',
              pfx:'表示の有無',
              ld_itemss: [
                {key:'10', pfx: '表示する'},
                {key:'0', pfx: '表示しない'},
              ],
              b_setValOnChg:false,
            },
          ],
        }}
      />
    );
  };
};

export default iPdtDtl;
